import clsx from 'clsx';
import React from 'react';

import s from './Notice.module.less';

export interface NoticeProps extends React.HTMLAttributes<HTMLDivElement> {
  secondary?: boolean;
  italic?: boolean;
}

export const Notice: React.FC<NoticeProps> = (props) => {
  const { secondary, italic, className, children, ...rest } = props;

  return (
    <div
      {...rest}
      className={clsx(s.root, className, {
        [s.italic]: italic,
        [s.secondary]: secondary,
      })}
    >
      {children}
    </div>
  );
};
